// extracted by mini-css-extract-plugin
export default {"img":"NotFoundPage_img__1eqez","text":"NotFoundPage_text__3dOc0"};